<template>
<!-- 結果発表詳細 -->
  <div class="results-detail">
    <h2 class="page-title"><p class="txt" :class="[this.$route.params.lang]" v-html="$t('text001')" /></h2>

    <div class="ranking-nav">
      <button class="btn-nav-back" :class="[this.$route.params.lang]" @click="goToResult()" />
      <div class="ranking-list-wrap">
        <ul>
          <li><span v-html="$t('text007')" @click="goToResultDetail(1)" /></li>
          <li><span v-html="$t('text008')" @click="goToResultDetail(2)" /></li>
          <li><span v-html="$t('text009')" @click="goToResultDetail(3)" /></li>
          <li><span v-html="$t('text010')" @click="goToResultDetail(4)" /></li>
        </ul>
      </div>
    </div>

    <table class="ranking-table">
      <thead>
        <tr>
          <th class="table-ranking" v-html="$t('text012')" />
          <th class="table-name">
            <p v-html="$t('text014')" />
            <p class="table-series-name" v-html="$t('text015')" />
          </th>
          <th class="table-vote" v-html="$t('text013')" />
        </tr>
      </thead>
      <tbody>
        <template v-for="(item,i) in rankingList" >
          <table-row :hero="item" :key="i" />
        </template>
      </tbody>
    </table>

    <div class="ranking-nav">
      <div class="btn-nav-back" :class="[this.$route.params.lang]" @click="goToResult()" />
      <div class="ranking-list-wrap">
        <ul>
          <li><span v-html="$t('text007')" @click="goToResultDetail(1)" /></li>
          <li><span v-html="$t('text008')" @click="goToResultDetail(2)" /></li>
          <li><span v-html="$t('text009')" @click="goToResultDetail(3)" /></li>
          <li><span v-html="$t('text010')" @click="goToResultDetail(4)" /></li>
        </ul>
      </div>
    </div>

    <div class="line" />

    <btn-official />

    <app-download class="app-download" />
    <div class="bg-footer">
      <sns-share share-text="footer.share.result" :replace-text="replaceText">
        <img :src="require(`@images/sns-share/${this.$route.params.lang}/text_share.png`)" />
      </sns-share>
      <trademark />
    </div>
  </div>
</template>

<script>
import allRanking from '@constants/all-ranking'
import store from '@/store/index'

import TableRow from '@components/result/table-item.vue'
import BtnOfficial from '@components/global/button-official.vue'
import AppDownload from '@components/global/app-download.vue'
import SnsShare from '@components/global/sns-share.vue'
import Trademark from '@components/global/trademark.vue'

import localeResult from '@locales/result'

export default {
  name: 'results-detail',
  beforeRouteEnter: (to, from, next) => {
    if (store.getters['menu/termType'] === 3) {
      if (to.params.page > 0 && to.params.page < 5) {
        next()
      } else {
        next(`/${to.params.lang}/results/1`)
      }
    } else {
      next('/')
    }
  },
  $messages: localeResult,
  components: {
    TableRow,
    BtnOfficial,
    AppDownload,
    SnsShare,
    Trademark,
  },
  computed: {
    replaceText() {
      return { url: `${location.origin}/${this.$route.params.lang}/results/${this.$route.params.page}` }
    },
    rankingList(){
      switch (this.$route.params.page) {
        case '1':
          return allRanking.filter((r,i) => i >= 0 && i < 200)
        case '2':
          return allRanking.filter((r,i) => i >= 200 && i < 400)
        case '3':
          return allRanking.filter((r,i) => i >= 400 && i < 600)
        case '4':
          return allRanking.filter((r,i) => i >= 600)
        default:
          return null
      }
    },
  },
  methods: {
    goToResult() {
      this.$router.push(`/${this.$route.params.lang}/results`)
      window.scrollTo(0, 0)
    },
    goToResultDetail(page) {
      this.$router.push(`/${this.$route.params.lang}/results/${page}`)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>

.page-title {
  box-sizing: border-box;
  width: 640px;
  height: 60px;
  margin-top: 30px;
  background: url(#{$img-path}bg_page-title.png) no-repeat;
  background-position: center;
  .txt {
    position: relative;
    margin: 0 auto;
    height: 52px;
    @include hidden-text();
    background-repeat: no-repeat;
    background-position: center center;
    &.ja-JP {
      background-image: url(#{$img-path}result/ja-JP/txt_result.png);
    }
    &.de-DE {
      background-image: url(#{$img-path}result/de-DE/txt_result.png);
    }
    &.en-GB {
      background-image: url(#{$img-path}result/en-GB/txt_result.png);
    }
    &.en-US {
      background-image: url(#{$img-path}result/en-US/txt_result.png);
    }
    &.es-ES {
      background-image: url(#{$img-path}result/es-ES/txt_result.png);
    }
    &.es-MX {
      background-image: url(#{$img-path}result/es-MX/txt_result.png);
    }
    &.fr-CA {
      background-image: url(#{$img-path}result/fr-CA/txt_result.png);
    }
    &.fr-FR {
      background-image: url(#{$img-path}result/fr-FR/txt_result.png);
    }
    &.it-IT {
      background-image: url(#{$img-path}result/it-IT/txt_result.png);
    }
    &.pt-BR {
      background-image: url(#{$img-path}result/pt-BR/txt_result.png);
    }
    &.zh-TW {
      background-image: url(#{$img-path}result/zh-TW/txt_result.png);
    }
  }
}

.ranking-nav {
  position: relative;
  height: 140px;
  margin: 30px 0;
  .btn-nav-back {
    position: absolute;
    top: 50%;
    left: 16px;
    margin-top: -56px;
  }
  .ranking-list-wrap {
    position: absolute;
    top: 0;
    right: 16px;
    text-align: center;
    ul {
      display: inline;
    }
  }
}
.btn-nav-back {
  display: block;
  @include hidden-text();
  background-repeat: no-repeat;
  background-position: left top;
  width: 108px;
  height: 112px;
  &.ja-JP {
    background-image: url(#{$img-path}common/ja-JP/btn_back.png);
  }
  &.de-DE {
    background-image: url(#{$img-path}common/de-DE/btn_back.png);
  }
  &.en-GB {
    background-image: url(#{$img-path}common/en-GB/btn_back.png);
  }
  &.en-US {
    background-image: url(#{$img-path}common/en-US/btn_back.png);
  }
  &.es-ES {
    background-image: url(#{$img-path}common/es-ES/btn_back.png);
  }
  &.es-MX {
    background-image: url(#{$img-path}common/es-MX/btn_back.png);
  }
  &.fr-CA {
    background-image: url(#{$img-path}common/fr-CA/btn_back.png);
  }
  &.fr-FR {
    background-image: url(#{$img-path}common/fr-FR/btn_back.png);
  }
  &.it-IT {
    background-image: url(#{$img-path}common/it-IT/btn_back.png);
  }
  &.pt-BR {
    background-image: url(#{$img-path}common/pt-BR/btn_back.png);
  }
  &.zh-TW {
    background-image: url(#{$img-path}common/zh-TW/btn_back.png);
  }
}
.ranking-list-wrap {
  box-sizing: border-box;
  width: 498px;
  height: 136px;
  margin: 0 auto 30px;
  padding: 16px 24px 14px;
  text-align: center;
  background: url(#{$img-path}result/bg_result-ranking.png) no-repeat;
  li {
    display: inline-block;
    width: 200px;
    padding: 3px 0 10px;
    font-size: $fs-base * 1.1;
    text-align: center;
    color: #fff;
    > span {
      text-decoration: underline;
      @include tap-event();
    }
    &:nth-child(-n + 2) {
      margin-bottom: 7px;
    }
    &:nth-child(even) {
      padding-right: 0;
    }
  }
}
.ranking-table {
  position: relative;
  width: 640px;
  margin-bottom: 30px;
  background-color: rgba(0, 0, 0, .2);
  background-image: url(#{$img-path}lin_list.png);
  background-repeat: no-repeat;
  background-position: bottom;
  border-spacing: 0;
  tr::after {
    position: absolute;
    left: 0px;
    display: block;
    width: 640px;
    height: 2px;
    background: url(#{$img-path}lin_list.png) no-repeat;
    content: '';
  }
  th {
    padding: 14px;
    font-weight: normal;
    font-size: $fs-base;
    line-height: 1.2;
    &.table-ranking {
      box-sizing: border-box;
      width: 100px;
      text-align: center;
    }
    &.table-name {
      box-sizing: border-box;
      width: 415px;
      text-align: left;
    }
    &.table-vote {
      box-sizing: border-box;
      width: 125px;
    }
    .table-series-name {
      color: #878787;
    }
  }
}

.line {
  height: 2px;
  margin: 0;
  background-image: url(~@images/common/line.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 2px;
  border: 0;
}
.bg-footer {
  background-color: rgba(0, 0, 0, .5);
}
.sns-share {
  margin-top: 20px;
}
</style>
